// topics_version = p<prompt>-c<catalog>-d<decisions wording>, e.g. p1-c089d5b20-d1
export const parseVersion = (version) => {
  const m = /^(p\w+)-c(\w+)-(d\w+)$/.exec(version || '');
  return m ? { prompt: m[1], catalog: m[2], decisions: m[3] } : null;
};

// p1 -> v1: the stored codes stay p1 / d1, the page says Prompt v1 / Questions v1
export const asV = (code) => `v${code.slice(1)}`;

export const versionLabel = (parsed) => ({
  prompt: `Prompt ${asV(parsed.prompt)}`,
  questions: `Questions ${asV(parsed.decisions)}`,
});

export const shortVersion = (version) => {
  const v = parseVersion(version);
  if (!v) return version;
  const label = versionLabel(v);
  return `${label.prompt} · ${label.questions}`;
};

export const versionTitle = (version) => {
  const v = parseVersion(version);
  if (!v) return version;
  const label = versionLabel(v);
  return `${label.prompt} : instructions de GPT Luna · ${label.questions} : questions de l'API Decisions · catalogue de topics ${v.catalog}`;
};
